import { A_PROPERTIES_STATUS_ARRAY } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyCardStatus = (
  property: IPropertyDetailsResponse
) => {
  return A_PROPERTIES_STATUS_ARRAY.find(status => status.id === property.status_id)
    ?.label;
};
